import { render, staticRenderFns } from "./opportunityForm.vue?vue&type=template&id=12580892&scoped=true&"
import script from "./opportunityForm.vue?vue&type=script&lang=js&"
export * from "./opportunityForm.vue?vue&type=script&lang=js&"
import style0 from "./opportunityForm.vue?vue&type=style&index=0&id=12580892&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12580892",
  null
  
)

export default component.exports